import Components from './../Component';
//import Swiper from 'swiper';

export default class Slider extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {

    var prevButton = this.$(element).find('.swiper-button-prev');
    if (this.$(element).attr('data-button-prev')) {
      prevButton = this.$(element).closest('section').find(this.$(element).attr('data-button-prev'));
      //console.log(prevButton);
    }
    var nextButton = this.$(element).find('.swiper-button-next');
    if (this.$(element).attr('data-button-next')) {
      nextButton = this.$(element).closest('section').find(this.$(element).attr('data-button-next'));
    }

    var slidesPerView = 'auto';
    if (this.$(element).attr('data-slidesperview')) {
      slidesPerView = this.$(element).attr('data-slidesperview');
    }

    var slidesPerGroup = 1;
    if (this.$(element).attr('data-slidespergroup')) {
      slidesPerGroup = this.$(element).attr('data-slidespergroup');
    }

    this.slider = new Swiper(this.$(element).find('.swiper-container'), {
      slidesPerView: slidesPerView,
      slidesPerGroup: slidesPerGroup,
      a11y:true,
      spaceBetween: 0,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      }
    });

    //console.log(this.slider);

  }

}